var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PCNavbar'),_c('MobileNavBar'),_c('div',{staticClass:"video-page"},[_c('VideoList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }